import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import Text from "aldoo-ra/Text"
import PubSub from "pubsub-js"
import Image from "aldoo-ra/Image"
import config from "aldoo-ra/Config"
import CMSData from "aldoo-ra/CMS/cms-data"

const Signin = ({ redirect }) => {
  const { data: supportEmailData } = CMSData({
    contentType: "Text",
    match: { "content.id": "support_email" },
  })

  const supportEmail = supportEmailData?.[0]?.text

  const handleSignin = () => {
    PubSub.publish("signin", {
      redirect: redirect || "/admin",
      require: "aldoo", // Require aldoo role permissions for admin access
    })
  }

  return (
    <div className="min-h-screen bg-admin_canvas flex flex-col items-center justify-center p-8">
      <div className="w-full max-w-md bg-admin_paper rounded-2xl shadow-lg p-8 flex flex-col items-center">
        {/* Logo placeholder - you can replace with your actual logo component */}
        <div className="w-24 h-24 mb-6 flex items-center justify-center">
          <Image
            id="product_logo_small"
            className="w-full h-full"
          />
        </div>

        <Typography
          variant="admin_h2"
          className="font-semibold text-center text-admin_text"
        >
          Welcome to
        </Typography>

        <Text
          id="site_name"
          variant="admin_h1"
          className="font-bold text-center text-admin_text mb-8"
          fallback={config.APP_NAME}
        />

        <Typography 
          variant="admin_body_dim" 
          className="text-center mt-0 mb-8"
        >
          Sign in to access your dashboard and manage your site features.
        </Typography>

        <Button
          variant="admin_secondary"
          className="w-[200px] py-3 flex items-center justify-center"
          onClick={handleSignin}
        >
          Sign In
        </Button>

        {supportEmailData?.[0]?.text && (
          <div className="mt-6 text-sm text-center">
            <a
              href={`mailto:${supportEmail}`}
              className="text-admin_primary hover:underline"
            >
              Need help? Contact support
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default Signin
